import { useState, useEffect } from 'react';
import NumberCustomSelector from '../UI/NumberCustomSelector/NumberCustomSelector';
import { useDangerProducts, useDeleteDangerProducts, useCreateDangerProducts, useEditDangerProducts } from '../../api/danger-products/danger-products.hook'
import addBtn from '../../assets/addBtn.svg';
import searchBtn from '../../assets/searchBtn.svg';
import editBtn from '../../assets/editBtn.svg';
import deleteBtn from '../../assets/deleteBtn.svg';
import closeBtnModal from '../../assets/closeBtnModal.svg';
import { useTranslation } from 'react-i18next';
import { Modal, message, Pagination } from 'antd';
import './style.css';


const ProhibitedGoods = () => {
	const { t } = useTranslation();
	const [isAddModalVisible, setAddModalVisible] = useState(false);
	const [isEditModalVisible, setEditModalVisible] = useState(false);
	const [isDangerProductName, setDangerProductName] = useState('');
	const [editingProduct, setEditingProduct] = useState({ id: null, name: '' });
	const [paginationPage, setPaginationPage] = useState(0);
	const [searchTerm, setSearchTerm] = useState('');
	const [initialState, setInitialState] = useState({
    nameSearch: '',
    page: paginationPage,
    size: 20,
	});
	const { data, refetch } = useDangerProducts(initialState);
	const { mutate } = useDeleteDangerProducts();
	const { mutate: mutateCreate } = useCreateDangerProducts();
	const { mutate: mutateEdit } = useEditDangerProducts();
	const totalPages = data?.totalPages || 0;
	
	const dangeresData =
    data?.content.map((danger) => ({
      id: danger.id,
      name: danger.name || '',
		})) || [];
	
	const openEditModal = (product) => {
    setEditingProduct({ id: product.id, name: product.name });
    setEditModalVisible(true);
  };
	
	const handleEdit = () => {
    if (!editingProduct.name.trim()) {
      message.warning(t('dangerProducts.placeholder'));
      return;
    }

    mutateEdit(
      { id: editingProduct.id, name: editingProduct.name },
      {
        onSuccess: () => {
          message.success(t('dangerProducts.updateSuccess'));
          setEditModalVisible(false);
          refetch();
        },
        onError: (error) => {
          message.error(`${t('dangerProducts.updateError')} ${error}`);
        },
      }
    );
  };
	
	const handlePageChange = (page) => {
    setPaginationPage(page - 1);
    setInitialState((prevState) => ({
      ...prevState,
      page: page - 1,
    }));
  };
	
	const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setInitialState((prevState) => ({
      ...prevState,
      nameSearch: e.target.value,
      page: 0,
    }));
    setPaginationPage(0);
  };

	const handleSizeChange = (value) => {
    setInitialState((prevState) => ({
      ...prevState,
      size: Number(value),
      page: 0,
    }));
    setPaginationPage(0);
	};

	const handleDelete = (id) => {
    mutate(
      { id },
      {
        onSuccess: () => {
          message.success(t('dangerProducts.deleteSuccess'));
          refetch();
        },
        onError: (error) => {
          message.error(`${t('dangerProducts.deleteError')} ${error}`);
        },
      },
    );
	};
	
	const handleCreate = (name) => {
		if (!name.trim()) {
			message.warning(t('dangerProducts.placeholder'));
			return;
  	}

    mutateCreate(
      { name },
      {
        onSuccess: () => {
					message.success(t('dangerProducts.createSuccess'));
					setDangerProductName(''); 
        	setAddModalVisible(false);
          refetch();
        },
        onError: (error) => {
          message.error(`${t('dangerProducts.createError')} ${error}`);
        },
      },
    );
	};
	
	const openAddModal = () => {
    setAddModalVisible(true);
  };
	
	useEffect(() => {
    refetch();
  }, [initialState, refetch]);

	return (
		<div className='danger-products-page'>
			<div className='danger-products-page__content'>
				<div className='danger-products-page__header'>
					<h1 className='danger-products-page__title'>{t('dangerProducts.title')}</h1>
					<button className='danger-products-page__addBtn' onClick={() => openAddModal()}>
						<img src={addBtn} alt="addBtn" />
					</button>
				</div>

				<div className="danger-products-page__subheader">
          <div className="search-elem">
						<button className="search-elem__btn">
							<img src={searchBtn} alt="searchIcn" />
						</button>
						<input
							type="text"
							className="search-input"
							placeholder={t('dangerProducts.search')}
							value={searchTerm}
							onChange={handleSearchChange}
						/>
					</div>
          <NumberCustomSelector
            defaultValue="20"
            className="danger-products-page__size"
            onChange={handleSizeChange}
            options={[
              { value: '20', label: '20' },
              { value: '40', label: '40' },
              { value: '100', label: '100' },
            ]}
          />
				</div>
				
				<div className="danger-products-page__table-container">
					<div className="danger-products-page__table-header">
						<div className="danger-products-page__table-header-name">
							{t('dangerProducts.productName')}
						</div>

						<div className="danger-products-page__table-header-action">
							{t('dangerProducts.actions')}
						</div>
					</div>

					<div className="danger-products-page__table-items">

						{dangeresData.length > 0 ? (dangeresData.map((danger) => (
							<div className="danger-products-page__item" key={danger.id}> 
								<div className='danger-products-page__table-item-name'>
									{danger.name}
								</div>
								<div className='danger-products-page__table-item-actions'>
									<button className='danger-products-page__table-item-edtiBtn' onClick={() => openEditModal(danger)} >
										<img src={editBtn} alt="edtiBtn" />
									</button>
									<button className='danger-products-page__table-item-deleteBtn' onClick={() => handleDelete(danger.id)}>
										<img src={deleteBtn} alt="deleteBtn" />
									</button>
								</div>
							</div>
						))) : (
							<div className="danger-products-page__item"> 
									<div className='danger-products-page__table-item-noData'>
										{t('dangerProducts.noData')}
									</div>
							</div>
						)}

					</div>
				</div>

				<div className="pagination-elem" style={{ display: totalPages <= 1 ? 'none' : 'flex' }}>
					<Pagination
						className="pagination-elem__custom"
						showSizeChanger={false}
						current={paginationPage + 1}
						total={totalPages}
						showLessItems={true}
						onChange={handlePageChange}
						pageSize={1}
						prevIcon={
							<button className="pagination-elem__prevBtn">
								{'<'}
							</button>
						}
						nextIcon={
							<button className="pagination-elem__nextBtn">
								{'>'}
							</button>
						}
					/>
				</div>
			</div>

			<Modal
				title={<div className="danger-products-page-modal__title">{t('dangerProducts.addTitle')}</div>}
				width={930}
				open={isAddModalVisible}
				onCancel={() => { setDangerProductName(''); setAddModalVisible(false); }}
				footer={null}
				centered
				className="danger-products-page-modal"
				closeIcon={null} 
			>
				<div className="custom-close-icon" onClick={() => { setDangerProductName(''); setAddModalVisible(false); }}>
						<img src={closeBtnModal} alt="closeBtn" />
				</div>

				<div className="danger-products-page-modal__input-block">
					<input
						type="text"
						placeholder={t('dangerProducts.nameLabel')}
						className="danger-products-page-modal__input"
						value={isDangerProductName}
						onChange={(e) => setDangerProductName(e.target.value)}
					/>
				</div>

				<div className="danger-products-page-modal__buttons">
					<button className="danger-products-page-modal__cancel-button" onClick={() => { setDangerProductName(''); setAddModalVisible(false); }}>
						{t('dangerProducts.cancel')}
					</button>
					<button className="danger-products-page-modal__do-button" onClick={() => handleCreate(isDangerProductName)}>
						{t('dangerProducts.add')}
					</button>
				</div>
				
			</Modal>
			

			<Modal
				title={<div className="danger-products-page-modal__title">{t('dangerProducts.editTitle')}</div>}
				width={930}
				open={isEditModalVisible}
				onCancel={() => setEditModalVisible(false)}
				footer={null}
				centered
				className="danger-products-page-modal"
				closeIcon={null} 
			>
				<div className="custom-close-icon" onClick={() => setEditModalVisible(false)}>
					<img src={closeBtnModal} alt="closeBtn" />
				</div>

				<div className="danger-products-page-modal__input-block">
					<input
						type="text"
						placeholder={t('dangerProducts.nameLabel')}
						className="danger-products-page-modal__input"
						value={editingProduct.name}
						onChange={(e) => setEditingProduct(prev => ({...prev, name: e.target.value}))}
					/>
				</div>

				<div className="danger-products-page-modal__buttons">
					<button 
						className="danger-products-page-modal__cancel-button" 
						onClick={() => setEditModalVisible(false)}
					>
						{t('dangerProducts.cancel')}
					</button>
					<button 
						className="danger-products-page-modal__do-button" 
						onClick={handleEdit}
					>
						{t('dangerProducts.edit')}
					</button>
				</div>
			</Modal>
		</div>
	);
};
export default ProhibitedGoods;
